import { render, staticRenderFns } from "./DeliveryPlatform.vue?vue&type=template&id=0153f7a3&scoped=true"
import script from "./DeliveryPlatform.vue?vue&type=script&lang=ts"
export * from "./DeliveryPlatform.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryPlatform.vue?vue&type=style&index=0&id=0153f7a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153f7a3",
  null
  
)

export default component.exports